import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { CreateProductScanDataRequest, CreateProductScanDataResponse, GetDownloadFilePathRespoonse, ProductResponse, QrProductFeedbackRequest } from './app.model';
import { CreateProductScanData } from './app.actions';

@Injectable({
  providedIn: 'root',
})

export class AppService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private getHeaders(tenantId: string): HttpHeaders {
    return new HttpHeaders({
      'x-tenant-id': tenantId
    });
  }

  public getProduct(
    qrCode: string,
    tenantId: string,
    gtin?: string | null,
  ): Observable<ProductResponse> {
    const params: Record<string, string> = {};
    if (gtin) {
      params['gtin'] = String(gtin);
    }
    return this.http
      .get<ProductResponse>(`${this.apiUrl}/api/qr-product-items/scan/${encodeURIComponent(qrCode)}`, {
        headers: this.getHeaders(tenantId),
        params,
      })
      .pipe(
        map(response => response),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  public createProductScanData(payload: CreateProductScanDataRequest, tenantId: string): Observable<CreateProductScanDataResponse> {
    return this.http
      .post<CreateProductScanDataResponse>(`${this.apiUrl}/api/product-scan-data`, payload, {
        headers: this.getHeaders(tenantId)
      })
      .pipe(
        map(response => response)
      );
  }

  public qrProductFeedback(payload: QrProductFeedbackRequest, tenantId: string): Observable<ProductResponse> {
    return this.http
      .post<ProductResponse>(`${this.apiUrl}/api/qr-product-feedback`, payload, {
        headers: this.getHeaders(tenantId)
      })
      .pipe(
        map(response => response),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  public getDownloadFilePath(key: string, bucket: string): Observable<GetDownloadFilePathRespoonse> {
    return this.http
      .get<GetDownloadFilePathRespoonse>(`${this.apiUrl}/api/storage/download?bucketName=${bucket}&filePath=${key}`)
      .pipe(
        map(response => response),
        catchError(error => {
          return throwError(
            () => new Error('Error fetching data: ' + error.message)
          );
        })
      );
  }
}